import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-62643b10"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "rating-stars__desc" }

import { computed } from "vue";

import SvgStar from "@/components/svg/SvgStar.vue";

type starType = "small" | "medium" | "large";


export default /*#__PURE__*/_defineComponent({
  __name: 'RatingStars',
  props: {
  modelValue: {
    type: Number,
    default: 2
  },
  disabled: {
    type: Boolean,
    default: false
  },
  max: {
    type: Number,
    default: 5
  },
  color: {
    type: String,
    default: "#ffcf42"
  },
  selectedColor: String,
  unselectedColor: String,
  size: {
    type: String,
    default: "small",
    validator: (prop: starType) => ["small", "medium", "large"].includes(prop)
  },
  textList: {
    type: Array,
    validator(value: string[]) {
      return value.length <= 5;
    }
  }
},
  emits: ["update:modelValue"],
  setup(__props, { emit }: { emit: ({
  (e: "update:modelValue", value: number): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const customClazz = computed(() => ({
    "rating-stars--small": props.size === "small",
    "rating-stars--medium": props.size === "medium",
    "rating-stars--large": props.size === "large",
  }))

const starSelected = (starIndex: number) => {
  const starIndexMod = starIndex + 1;
  const allStars = document.querySelectorAll(".rating-stars__wrap");

  allStars.forEach((el, index) => {
    el.classList.remove("is-active");
    
    if(index < starIndexMod) {
      el.classList.add("is-active")
    }
  });

  emit("update:modelValue", starIndexMod);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rating-stars", [
      {'is-disabled': __props.disabled},
      _unref(customClazz)
    ]])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.max, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: _normalizeClass(["rating-stars__wrap", {'is-active': index < __props.modelValue}]),
        onClick: ($event: any) => (starSelected(index))
      }, [
        _createVNode(SvgStar, { class: "rating-stars__star" }),
        _createElementVNode("p", _hoisted_2, _toDisplayString(__props.textList![index]), 1)
      ], 10, _hoisted_1))
    }), 128))
  ], 2))
}
}

})